

document.addEventListener('DOMContentLoaded', () => {
    var openMenuButton = document.querySelector('.header-menu-open');
    var closeMenuButton = document.querySelector('.header-menu-close');

    if (openMenuButton) {
        openMenuButton.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.add('header-menu-visible');
        });
    }
    if (closeMenuButton) {
        closeMenuButton.addEventListener('click', () => {
            document.body.classList.remove('header-menu-visible');
        });
    }

    //Toggle Language Switcher
    var languageSwitcherToggleButton = document.querySelector('.language-switcher > a.language-active');
    if (languageSwitcherToggleButton) {
        languageSwitcherToggleButton.addEventListener('click', (e) => {
            e.preventDefault();
            languageSwitcherToggleButton.parentNode.classList.toggle('active');
        });
    }

    // Text size controls
    const ts = document.querySelector('.js-ts-controls');
    function updateTextSize(fontSize) {
        document.documentElement.style.setProperty('--font-size', fontSize + 'px');
    }
    if (ts) {
        const MAXFONTSIZE = 20;
        const MINFONTSIZE = 14;
        let currentFontSize = 16;
        ts.addEventListener('click', ({target}) => {
            if (target.className.includes('js-ts-min')) {
                currentFontSize = (currentFontSize > MINFONTSIZE) ? currentFontSize - 1 : currentFontSize;
                updateTextSize(currentFontSize);
            }
            if (target.className.includes('js-ts-max')) {
                currentFontSize = (currentFontSize < MAXFONTSIZE) ? currentFontSize + 1 : currentFontSize;
                updateTextSize(currentFontSize);
            }
        });
    }
    
});





// WEBPACK FOOTER //
// ./assets/src/js/modules/menu.js